import {
    SEND_COMMAND_OPEN_MODAL,
    SEND_COMMAND_CLOSE_MODAL,
    SEND_COMMAND_GET_DEVICE_REQUEST,
    SEND_COMMAND_GET_DEVICE_RESULT,
    SEND_COMMAND_REQUEST,
    SEND_COMMAND_RESULT,
    SEND_COMMAND_SET_DEVICES,
    SEND_COMMAND_SEARCH_DEVICE_MODEL_REQUEST,
    SEND_COMMAND_SEARCH_DEVICE_MODEL_RESULT,
    SEND_COMMAND_SEARCH_COMMANDS_REQUEST,
    SEND_COMMAND_SEARCH_COMMANDS_RESULT,
    SEND_COMMAND_SEARCH_MASS_COMMANDS_REQUEST,
    SEND_COMMAND_SEARCH_MASS_COMMANDS_RESULT,
    SEND_COMMAND_GET_DETAILS_REQUEST,
    SEND_COMMAND_GET_DETAILS_RESULT,
    SEND_COMMAND_GENERAL_REQUEST,
} from 'Redux/actionTypes';

export const sendCommandGeneralRequest = (data) => ({
    type: SEND_COMMAND_GENERAL_REQUEST,
    payload: data,
})
export const sendCommandSearchCommandsRequest = (data) => ({
    type: SEND_COMMAND_SEARCH_COMMANDS_REQUEST,
    payload: data,
})

export const sendCommandSearchCommandsResult = (result) => ({
    type: SEND_COMMAND_SEARCH_COMMANDS_RESULT,
    payload: result,
})

export const sendCommandSearchMassCommandsRequest = (data) => ({
    type: SEND_COMMAND_SEARCH_MASS_COMMANDS_REQUEST,
    payload: data,
})

export const sendCommandSearchMassCommandsResult = (result) => ({
    type: SEND_COMMAND_SEARCH_MASS_COMMANDS_RESULT,
    payload: result,
})

export const sendCommandSearchDeviceModelRequest = (data) => ({
    type: SEND_COMMAND_SEARCH_DEVICE_MODEL_REQUEST,
    payload: data
})

export const sendCommandSearchDeviceModelResult = (result) => ({
    type: SEND_COMMAND_SEARCH_DEVICE_MODEL_RESULT,
    payload: result
})

export const sendCommandOpenModal = (data) => ({
    type: SEND_COMMAND_OPEN_MODAL,
    payload: data
})

export const sendCommandCloseModal = () => ({
    type: SEND_COMMAND_CLOSE_MODAL,
})

export const sendCommandGetDeviceRequest = (data) => ({
    type: SEND_COMMAND_GET_DEVICE_REQUEST,
    payload: data,
})

export const sendCommandGetDeviceResult = (result) => ({
    type: SEND_COMMAND_GET_DEVICE_RESULT,
    payload: result,
})

export const sendCommandRequest = (data) => ({
    type: SEND_COMMAND_REQUEST,
    payload: data,
})

export const sendCommandResult = (result) => ({
    type: SEND_COMMAND_RESULT,
    payload: result,
})

export const sendCommandSetDevices = (data) => ({
    type: SEND_COMMAND_SET_DEVICES,
    payload: data,
})

export const sendCommandGetDetailsRequest = (data) => ({
    type: SEND_COMMAND_GET_DETAILS_REQUEST,
    payload: data,
})

export const sendCommandGetDetailsResult = (result) => ({
    type: SEND_COMMAND_GET_DETAILS_RESULT,
    payload: result,
})